import { SEED_IMAGES } from "@dc-ireland/shared"

export type HeroSlide = {
  id: string
  slug?: string
  src: string
  label: string
  caption: string
}

export const defaultHeroSlides: HeroSlide[] = [
  {
    id: "worship",
    slug: "worship",
    src: SEED_IMAGES.heroSlides.worship,
    label: "Worship",
    caption: "Spirit-filled gatherings across Ireland",
  },
  {
    id: "scripture",
    slug: "scripture",
    src: SEED_IMAGES.heroSlides.scripture,
    label: "Scripture",
    caption: "Rooted in the living Word of God",
  },
  {
    id: "dublin",
    slug: "dublin",
    src: SEED_IMAGES.heroSlides.dublin,
    label: "Dublin",
    caption: "Dominion City in the heart of the capital",
  },
  {
    id: "cork",
    slug: "cork",
    src: SEED_IMAGES.heroSlides.cork,
    label: "Cork",
    caption: "Faith, fellowship & purpose in Munster",
  },
  {
    id: "growth",
    slug: "growth",
    src: SEED_IMAGES.heroSlides.growth,
    label: "Spiritual Growth",
    caption: "Deepen your walk with Christ",
  },
  {
    id: "experience",
    slug: "experience",
    src: SEED_IMAGES.heroSlides.experience,
    label: "Worship Experience",
    caption: "Encounter God in every gathering",
  },
]

/** @deprecated Use defaultHeroSlides */
export const heroSlides = defaultHeroSlides
